/*
 * ABOUTME: Central configuration for dashboard graph date range behavior.
 * Controls whether today's data is excluded from graphs and score comparisons.
 */

/*
 * When true, graphs end at yesterday (excluding today's partial data).
 * When false, graphs include today's data in real time.
 */
const EXCLUDE_TODAY = false;

export default EXCLUDE_TODAY;